namespace $.$$ {
	const { rem } = $mol_style_unit
	$mol_style_define( $shm_showcase, {
		height: '100%',
		alignSelf: 'stretch',
		Menu: {
			flex: { basis: rem( 28 ), grow: 0, shrink: 0 },
		},
		Menu_link: {
			whiteSpace: 'normal',
			flex: { grow: 0 },
		},
		Welcome: { flex: { basis: rem( 60 ), grow: 1, shrink: 0 } },
	} )
}
